import { render, staticRenderFns } from "./TextFieldDialog.vue?vue&type=template&id=237e944c&"
import script from "./TextFieldDialog.vue?vue&type=script&lang=js&"
export * from "./TextFieldDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports